export const First = () => {
  return (
    <svg
      width={449}
      height={274}
      viewBox="0 0 449 274"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity={0.8}
        d="M436.696 0H11.469C5.135 0 0 5.135 0 11.47V261.61c0 6.334 5.135 11.469 11.47 11.469h425.226c6.334 0 11.469-5.135 11.469-11.469V11.469C448.165 5.135 443.03 0 436.696 0z"
        fill="url(#paint0_linear_6778_773)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6778_773"
          x1={0}
          y1={273.08}
          x2={448.165}
          y2={273.08}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0A92AF" />
          <stop offset={1} stopColor="#02A299" />
        </linearGradient>
      </defs>
    </svg>
  );
};
